import React from 'react';

import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {Filter} from 'presentation/components/Filter';
import {useQueryParams} from 'presentation/pages/private/hooks';
import {useGetHealthSpecialtiesQuery} from 'presentation/modules/booking/shared/queries/useGetHealthSpecialtiesQuery';

export function HealthFilterByLetter() {
	const {SEARCH_PARAMS} = useQueryParams();
	const {query} = SEARCH_PARAMS;

	const {
		data: specialtiesList,
		isError: specialtiesListError,
		isFetching: isFetchingSpecialtiesList,
	} = useGetHealthSpecialtiesQuery({isTelemedicine: false});

	const NOT_FOUND = !specialtiesList || specialtiesList.length === 0;
	const HIDDEN_FILTER_BY_LETTER = specialtiesListError || isFetchingSpecialtiesList || NOT_FOUND;

	if (HIDDEN_FILTER_BY_LETTER) {
		return null;
	}

	const FILTERED_LIST_BY_CATEGORY = specialtiesList.map(specialty => ({
		...specialty,
		list: specialty.list.filter(item =>
			item.formattedText.toLowerCase().includes(query.trim().toLowerCase()),
		),
	}));

	return (
		<Filter.Letter
			dataTagId={AppointmentBookingEnum.CLICK_FILTRAR_ESPECIALIDADE}
			filteredList={FILTERED_LIST_BY_CATEGORY}
		/>
	);
}
